import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	importInProgress: {
		id: 'project-create-import-progress.import-progress-button.progress-button.use-button-variation.import-in-progress',
		defaultMessage: 'Import in progress',
		description: 'Import in progress button displayed next to the project header',
	},
	importComplete: {
		id: 'project-create-import-progress.import-progress-button.progress-button.use-button-variation.import-complete',
		defaultMessage: 'Import complete',
		description: 'Import complete button displayed next to the project header',
	},
	importInComplete: {
		id: 'project-create-import-progress.import-progress-button.progress-button.use-button-variation.import-in-complete',
		defaultMessage: 'Import incomplete',
		description: 'Import incomplete button displayed next to the project header',
	},
});
